import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Type } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';

export interface TypeElement {
    'typeID': number,
    'name': string,
    'category': string,
    'description': string
}


@Injectable()
export class TypeService {
    allTypelList: BehaviorSubject<TypeElement[] | null> = new BehaviorSubject<TypeElement[] | null>(null);
    allTypeKey: BehaviorSubject<{ [key: string]: string } | null> = new BehaviorSubject<{ [key: string]: string } | null>(null);
    catTypeList: BehaviorSubject<TypeElement[] | null> = new BehaviorSubject<TypeElement[] | null>(null);
    catTypeKey: BehaviorSubject<{ [key: string]: string } | null> = new BehaviorSubject<{ [key: string]: string } | null>(null);
    loadFailed = false;
    category = '';

    constructor(private http: HttpClient, private oktaService: OktaService) { };

    get allTypesUpdated(): Observable<TypeElement[] | null> {
        return this.allTypelList.asObservable();
    }

    get catTypesUpdated(): Observable<TypeElement[] | null> {
        return this.catTypeList.asObservable();
    }

    get allTypeKeyUpdated(): Observable<{ [key: string]: string } | null> {
        return this.allTypeKey.asObservable();
    }

    get catTypeKeyUpdated(): Observable<{ [key: string]: string } | null> {
        return this.catTypeKey.asObservable();
    }

    createKey(typeList: TypeElement[]) {
        let keyObj: { [key: string]: string } = {};

        typeList.forEach(element => {
            keyObj[element.typeID.toString()] = element.name;
        });

        return keyObj
    }


    loadAllTypes() {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/types', options)
            .subscribe({
                next: data => {
                    this.allTypelList.next(data);
                    this.allTypeKey.next(this.createKey(data));
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.allTypelList.next(null);
                    console.log(msg);
                }
            });
    }


    loadCatTypes(category: string) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/admin.types/' + category, options)
            .subscribe({
                next: data => {
                    this.catTypeList.next(data);
                    this.catTypeKey.next(this.createKey(data));
                    this.category = category;
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.catTypeList.next(null);
                    console.log(msg);
                }
            });
    }

    addType(target: TypeElement) {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.types.add',
            {
                name: target.name,
                category: target.category,
                description: target.description
            },
            options
        )
    }

    updateType(target: TypeElement) {
        // Update target in database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.types.update',
            {
                typeID: target.typeID,
                name: target.name,
                category: target.category,
                description: target.description
            },
            options
        )
    }

    removeType(target: TypeElement) {
        //Remove target from database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.types.remove',
            {
                typeID: target.typeID
            },
            options
        )
    }
}